import React from 'react';
import { FaClock } from 'react-icons/fa';
import './Experience.css';
import { useData } from './DataProvider';

const Experience = () => {
  const { experienceData } = useData();

  return (
    <div className="experience-container">
      <div className="experience-header">
        <h2 className="experience-title">Experience</h2>
      </div>

      <div className="track-list-header">
        <div>#</div>
        <div>Role</div>
        <div>Description</div>
        <div><FaClock /></div>
      </div>

      <div className="experience-list">
        {experienceData.map((exp, idx) => (
          <div key={idx} className="role-row">
            <div className="role-logo-col">
              {exp.logo ? (
                <img src={exp.logo} alt={exp.company} className="role-logo" />
              ) : (
                <div className="role-logo-placeholder">{exp.company?.charAt(0) || idx + 1}</div>
              )}
            </div>

            <div className="role-main-col">
              <div className="role-title">{exp.title}</div>
              <div className="role-company">{exp.company}</div>
            </div>

            <div className="role-description-col">
              {exp.bullets && exp.bullets[0]}
            </div>

            <div className="role-date-col">
              {exp.start} - {exp.end}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Experience;
